import { GlobalVariable } from '../../../src/config/constant';
import messageService from '../message/messageService';
const UseCommonService = () => {

  let title = '';
  let breadcrumb = ''; 

  const getToken = () => {
    return localStorage.getItem(GlobalVariable.tokenKey) || '';
  };

  const setToken = (data: string) => {
    localStorage.setItem(GlobalVariable.tokenKey, data);
  };

  const setLocalData = (key: string, data: string, json = false) => {
    localStorage.setItem(key, json ? JSON.stringify(data) : data);
  };

  const getLocalData = (key: string, json = false) => {
    try {
      const data = localStorage.getItem(key);
      if (data === null) {
        return null;
      }
      return json ? JSON.parse(data) : data;
    } catch (error) {
      console.error('Error parsing local data:', error);
      return null;
    }
  };
  
  const clearAllLocalData = () => {
    localStorage.clear();
  };

  const checkBlockUnblock =(data:any) => {
    const messageServices = messageService(); 

    messageServices.toast('success', `${data.is_blocked ? 'Unblocked' : 'Blocked'} Successfully!`);
    data.is_blocked = !data.is_blocked;
  }


  const clearLocalData = (key: string) => {
    localStorage.removeItem(key);
  };

  const goBack = () => {
    window.history.back();
  };

  return {    
    getToken,
    setToken,
    setLocalData,
    getLocalData,
    clearAllLocalData,
    clearLocalData,
    goBack,
    checkBlockUnblock,
    title, 
    breadcrumb 
  };
};

export default UseCommonService;
